'use client';

import { useEffect, useState } from 'react';
import Image from 'next/image';
import { imageUrlParser } from '@bts-web/utils-formatting';

const AccordionContentImage: React.FC<{
  title: string;
  image: string;
  fallbackImage?: string;
  width: number;
  height: number;
}> = ({ image, fallbackImage, title, height, width }) => {
  /*
- the useState has been inserted as storage for the URL of the file, to be used in the onError event
- do not select to modify the <img src /> of the <Image /> element directly since it breaks the relationship in between the VirtualDOM and the DOM and caching mechanisms
*/
  const [imageSrc, setImageSrc] = useState<string | undefined>(
    () => image ?? fallbackImage,
  );

  useEffect(() => {
    setImageSrc(image);
  }, [image]);

  if (!imageSrc) {
    return null;
  }

  return (
    <Image
      data-testid="accordion-item-content-image"
      priority
      src={imageUrlParser(imageSrc)}
      alt={title}
      width={width}
      // leave this to off, vercel has unsolved bug caching issues and we get them from the CDN compressed and resized anyway
      unoptimized
      height={height}
      onError={() => {
        setImageSrc(fallbackImage ?? undefined);
      }}
    />
  );
};

export { AccordionContentImage };
